import { useMemo } from 'preact/hooks'

import render from '../../../wp/render'

export const Body = ({ content }) => {
  return useMemo(
    () => render(content),
    [content],
  )
}
